module.exports = __webpack_public_path__ + "static/media/dd-logo.4ae8a14f.svg";